import { render, staticRenderFns } from "./modal-manage.vue?vue&type=template&id=77fc77c2&scoped=true&"
import script from "./modal-manage.vue?vue&type=script&lang=js&"
export * from "./modal-manage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fc77c2",
  null
  
)

export default component.exports